
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './reducers/index'

/* to activate redux-logger in the console: uncomment the following
two lines, and loggerMiddleware arg passed to applyMiddleware()  */
// import { createLogger } from 'redux-logger'
// const loggerMiddleware = createLogger()

export default function configureStore (preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(
      thunkMiddleware
      // loggerMiddleware
    )
  )
}
